import { Routes, Route } from "react-router";
import SignIn from "../pages/guest_pages/SignIn";
import SignUp from "../pages/guest_pages/SignUp";
import ForgotPassword from "../pages/guest_pages/ForgotPassword";
import ResetPassword from "../pages/guest_pages/ResetPassword";
import VerifyAccount from "../pages/guest_pages/VerifyAccount";
import PublicRoute from "../utils/PublicRoute";
import VerifyOnlyRoute from "../utils/VerifyOnlyRoute";

const GuestRoutes = () => {
  return (
    <Routes>
      <Route
        path="/signin"
        element={
          <PublicRoute>
            <SignIn />
          </PublicRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <PublicRoute>
            <SignUp />
          </PublicRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/reset-password"
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        }
      />
      <Route
        path="/verify-account"
        element={
          <VerifyOnlyRoute>
            <VerifyAccount />
          </VerifyOnlyRoute>
        }
      />
    </Routes>
  );
};

export default GuestRoutes;